import { render } from "./Carousel-add.vue?vue&type=template&id=b3b883ec&scoped=true"
import script from "./Carousel-add.vue?vue&type=script&lang=js"
export * from "./Carousel-add.vue?vue&type=script&lang=js"

import "./Carousel-add.vue?vue&type=style&index=0&id=b3b883ec&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3b883ec"]])

export default __exports__